import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/nmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/nmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/nmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/nmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/nmain/${Id}`);
  },
};
